export default __webpack_public_path__ + "static/media/SecurityCheckpoint.f43b601c.svg";